import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import ThemeContext from "../utils/Contexts/ThemeContext";

function ContractsFilterModal({
  allStatuses,
  anyAffiliation,
  allTypes,
  activeStatusTab,
  setActiveStatusTab,
  activeAffiliationTab,
  setActiveAffiliationTab,
  setFormData,
  activeTypesTab,
  setActiveTypesTab,
  updatePendingFilter,
  pendingFilters,
}) {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);

  const applyFilters = () => {
    setFormData((prevData) => {
      const updatedFilters = [...prevData.search.filters];

      pendingFilters.forEach((filter) => {
        if (filter.key !== "UUID") {
          const filterIndex = updatedFilters.findIndex(
            (f) => f.key === filter.key
          );

          if (filterIndex !== -1) {
            updatedFilters[filterIndex] = {
              key: filter.key,
              value: filter.value,
            };
          } else {
            updatedFilters.push({ key: filter.key, value: filter.value });
          }
        }
      });

      return {
        ...prevData,
        length: 15,
        search: {
          ...prevData.search,
          filters: updatedFilters,
        },
      };
    });
    const modalElement = document.getElementById("offcanvasContractsFilter");
    if (modalElement) {
      modalElement.classList.remove("show"); // Removes the 'show' class to hide the modal
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show"); // Remove the backdrop if present
    }
  };

  const handleStatusTabClick = (value) => {
    setActiveStatusTab(value);
    updatePendingFilter("status", value);
  };

  const handleAffiliationTabClick = (value) => {
    setActiveAffiliationTab(value);
    updatePendingFilter("links_check", value);
  };

  const handleTypesTabClick = (value) => {
    setActiveTypesTab(value);
    updatePendingFilter("incoming", value);
  };

  const handleClearFilters = () => {
    setFormData((prevData) => ({
      ...prevData,
      search: {
        ...prevData.search,
        filters: [], // Clears the filters array
      },
    }));

    setActiveAffiliationTab(null);
    setActiveStatusTab(null);
    setActiveTypesTab(null);
    const modalElement = document.getElementById("offcanvasContractsFilter");
    if (modalElement) {
      modalElement.classList.remove("show"); // Removes the 'show' class to hide the modal
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show"); // Remove the backdrop if present
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end rounded-4"
      tabIndex="-1"
      id="offcanvasContractsFilter"
      aria-labelledby="offcanvasContractsFilterLabel"
      aria-hidden="true"
      style={{
        top: "21px",
        right: "0",
        bottom: "21px",
        marginRight: "12px",
        width: "calc(100% - 20px)",
        border:
          selectedTheme === "dark"
            ? "2px solid rgba(45, 50, 54, 1)"
            : "1px solid rgb(172, 172, 172)",
      }}
    >
      <div
        className="offcanvas-header px-3 pb-3"
        style={{
          borderBottom:
            selectedTheme === "dark"
              ? "2px solid rgba(45, 50, 54, 1)"
              : "1px solid rgb(172, 172, 172)",
        }}
      >
        <h3 id="offcanvasContractsFilterLabel" className="mb-0 pb-0">
          {t("Filters")}
        </h3>
      </div>
      <div className="offcanvas-body px-3 pt-3">
        <div className="row d-lg-none d-flex">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Status")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-lg-none d-flex">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between w-100"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                  role="tablist"
                >
                  {allStatuses.map((status) => {
                    return (
                      <li className="nav-item col-3" key={status.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeStatusTab === status.value ? "active" : ""
                          } `}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeStatusTab === status.value}
                          onClick={() => {
                            handleStatusTabClick(status.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                        >
                          {status?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-xl-none d-flex">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Link Check")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-xl-none d-flex">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {anyAffiliation.map((aff) => {
                    return (
                      <li className="nav-item col-3" key={aff.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeAffiliationTab === aff.value ? "active" : ""
                          } `}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeAffiliationTab === aff.value}
                          onClick={() => {
                            handleAffiliationTabClick(aff.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                        >
                          {aff?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-xl-none d-flex">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Link Check")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-xl-none d-flex">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {allTypes.map((type) => {
                    return (
                      <li className="nav-item col-3" key={type.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeTypesTab === type.value ? "active" : ""
                          } `}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeTypesTab === type.value}
                          onClick={() => {
                            handleTypesTabClick(type.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                        >
                          {type?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas-footer px-4 py-3">
        <div className="row gx-3">
          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-outline-primary py-2"
                onClick={handleClearFilters}
              >
                {t("Clear All Filters")}
              </button>
            </div>
          </div>

          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary py-2"
                onClick={applyFilters}
              >
                {t("Apply")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContractsFilterModal;
